/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Createevent1Inputs */

const en_createevent1 = /** @type {(inputs: Createevent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Event`)
};

const de_createevent1 = /** @type {(inputs: Createevent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event erstellen`)
};

/**
* | output |
* | --- |
* | "Create Event" |
*
* @param {Createevent1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const createevent1 = /** @type {((inputs?: Createevent1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Createevent1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_createevent1(inputs)
	return de_createevent1(inputs)
});
export { createevent1 as "createEvent" }